import { colors, s8 } from '@ardoq/design-tokens';
import { FIELD_SELECTOR } from '@ardoq/forms';
import { ellipsisCSS } from '@ardoq/style-helpers';
import { FlexBox } from '@ardoq/layout';
import { header4, text2 } from '@ardoq/typography';
import styled, { css } from 'styled-components';

interface WrapperProps {
  $isDisabled?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  ${props =>
    props.$isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;

export const Ellipsis = styled.span.attrs({ children: '...' })`
  color: ${colors.textModerate};
  ${header4};
  padding: 0 ${s8};
  font-size: 18px;
  letter-spacing: 2px;
`;

export const PaginationBarWithoutNumbersWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
`;

export const PaginationWithoutNumbersArrowWrapper = styled(FlexBox).attrs({
  justify: 'center',
  gap: 'medium',
})`
  grid-column: 2;
`;

export const LeftSideText = styled.div`
  flex: 1;
  justify-self: start;
  ${ellipsisCSS}
  ${text2}
`;

export const RightSideText = styled.div`
  flex: 1;
  display: flex;
  gap: ${s8};
  align-items: center;
  justify-content: flex-end;
  ${text2}

  ${FIELD_SELECTOR} {
    width: 87px; /* Exactly enough to show 4 digit numbers without ellipsis */
  }
`;

export const PageSelectorText = styled.span`
  ${ellipsisCSS}
`;
